/* ============================================================
   LUVZ — global behaviours (AJAX cart, drawer, thermal, UI)
   ============================================================ */
(function(){
  'use strict';
  document.documentElement.classList.remove('no-js');
  var R = (window.LUVZ && window.LUVZ.routes) || {cartAdd:'/cart/add.js',cartChange:'/cart/change.js',cart:'/cart.js'};

  /* ---------- helpers ---------- */
  function $(s,c){return (c||document).querySelector(s);}
  function $all(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));}
  function esc(s){
    return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }
  function formatMoney(cents){
    // render through the shop's real money_format so JS output matches Liquid's `| money`
    var fmt=(window.LUVZ&&window.LUVZ.money)||'CHF {{amount}}';
    function grp(s,sep){return s.replace(/\B(?=(\d{3})+(?!\d))/g,sep);}
    var f=(cents/100).toFixed(2), parts=f.split('.'), v;
    if(/amount_no_decimals_with_comma_separator/.test(fmt)){v=grp(String(Math.round(cents/100)),'.');}
    else if(/amount_no_decimals/.test(fmt)){v=grp(String(Math.round(cents/100)),',');}
    else if(/amount_with_comma_separator/.test(fmt)){v=grp(parts[0],'.')+','+parts[1];}
    else if(/amount_with_apostrophe_separator/.test(fmt)){v=grp(parts[0],"'")+'.'+parts[1];}
    else{v=grp(parts[0],',')+'.'+parts[1];}
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/,v).replace(/<[^>]*>/g,'');
  }

  /* ---------- cart drawer ---------- */
  var drawer=$('#cart-drawer'), overlay=$('#cart-overlay'), cartOpener=null;
  function openCart(){
    if(drawer){
      cartOpener=document.activeElement;
      drawer.classList.add('show');
      var c=drawer.querySelector('.drawer__close'); if(c)c.focus();
    }
    if(overlay){overlay.classList.add('show');}
  }
  function closeCart(){
    if(drawer){drawer.classList.remove('show');}
    if(overlay){overlay.classList.remove('show');}
    if(cartOpener&&cartOpener.focus){cartOpener.focus();cartOpener=null;}
  }
  document.addEventListener('keydown',function(e){
    if(e.key!=='Escape'||!drawer||!drawer.classList.contains('show'))return;
    /* the popup (z-120) sits above the drawer — let its own Escape handler win */
    if(document.querySelector('[data-popup].show'))return;
    closeCart();
  });
  window.luvzOpenCart=openCart; window.luvzCloseCart=closeCart;

  function renderUpsell(cart){
    var up=$('[data-upsell]'); if(!up)return;
    var inCart={};
    cart.items.forEach(function(i){inCart[i.product_id]=1;});
    var shown=0, MAX=2;
    $all('[data-upsell-card]',up).forEach(function(card){
      var pid=parseInt(card.getAttribute('data-product-id'),10);
      var show=cart.items.length>0 && !inCart[pid] && shown<MAX;
      card.hidden=!show;
      if(show)shown++;
    });
    up.hidden=(shown===0);
  }

  function renderCart(cart){
    var items=$('#cart-drawer-items'), countEls=$all('[data-cart-count]'),
        sub=$('#cart-drawer-subtotal'), ship=$('#cart-drawer-ship');
    countEls.forEach(function(el){el.textContent=cart.item_count; el.style.display=cart.item_count?'':'none';});
    if(drawer)drawer.classList.toggle('is-empty', !cart.items.length);
    var est=$('[data-est-bar]');
    if(est){
      var ph=(est.getAttribute('data-preorder-handles')||'').split(',').filter(Boolean);
      var hasPre=cart.items.some(function(i){return ph.indexOf(i.handle)>-1;});
      var estN=est.querySelector('[data-est-normal]'), estP=est.querySelector('[data-est-preorder]');
      if(estN)estN.hidden=hasPre;
      if(estP)estP.hidden=!hasPre;
    }
    renderUpsell(cart);
    if(!items) return;
    if(!cart.items.length){
      items.innerHTML='<div class="cart-empty">Your cart is empty.<br>Time to feel the heat.</div>';
      if(sub)sub.textContent=formatMoney(0);
      if(ship)ship.innerHTML='';
      return;
    }
    items.innerHTML=cart.items.map(function(i){
      var imgTag=i.image?'<img src="'+esc(i.image.replace(/(\.[^.]*)$/,'_120x$1'))+'" alt="'+esc(i.product_title)+'">':'';
      return '<div class="citem" data-key="'+esc(i.key)+'">'+
        imgTag+
        '<div><b>'+esc(i.product_title)+'</b>'+
        '<div class="csub">'+esc(i.variant_title&&i.variant_title!=='Default Title'?i.variant_title:'LUVZ Heat-Reactive')+'</div>'+
        '<div class="cunit">'+i.quantity+' × '+formatMoney(i.final_price)+'</div>'+
        '<div class="citem__row">'+
          '<div class="qty"><button data-line-minus aria-label="Decrease quantity">&minus;</button><span>'+i.quantity+'</span><button data-line-plus aria-label="Increase quantity">+</button></div>'+
          '<button type="button" class="citem__rm" data-line-remove>Remove</button>'+
        '</div>'+
        '</div><div class="citem__price">'+formatMoney(i.final_line_price)+'</div></div>';
    }).join('');
    if(sub)sub.textContent=formatMoney(cart.total_price);
    if(ship){
      // freeShip is the threshold in the SHOP's base currency (cents, e.g. 5000 = €50).
      // cart.total_price comes back in cents of the ACTIVE presentment currency, so we must
      // convert the threshold with Shopify's shop->presentment rate before comparing. Without
      // this, a high-rate currency (e.g. JPY) inflates total_price and unlocks shipping early.
      var baseThreshold=(window.LUVZ&&window.LUVZ.freeShip)||5000;
      var rate=(window.Shopify&&window.Shopify.currency&&parseFloat(window.Shopify.currency.rate))||1;
      var cur=(window.Shopify&&window.Shopify.currency&&window.Shopify.currency.active)||'';
      /* match checkout conditions exactly: CH zone = CHF (theme setting), everywhere else = €50;
         other presentment currencies approximate the €50 gate via the base rate */
      var threshold;
      if(cur==='CHF'){threshold=baseThreshold;}
      else if(cur==='EUR'){threshold=5000;}
      else{threshold=Math.round(baseThreshold*rate);}
      var remaining=Math.max(0,threshold-cart.total_price);
      var pct=threshold>0?Math.min(100,Math.round(cart.total_price/threshold*100)):100;
      if(cart.total_price>=threshold){
        ship.innerHTML='✓ You unlocked <b>FREE shipping</b><span class="ship-bar"><i style="width:100%"></i></span>';
      }else{
        ship.innerHTML='Add <b>'+formatMoney(remaining)+'</b> more for free shipping<span class="ship-bar"><i style="width:'+pct+'%"></i></span>';
      }
    }
  }

  function refreshCart(open){
    fetch(R.cart,{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){
      renderCart(c); if(open)openCart();
    });
  }

  function addToCart(id,qty){
    return fetch(R.cartAdd,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:id,quantity:qty||1})}).then(function(r){
        if(!r.ok)return r.json().then(function(e){throw e;});
        return r.json();
      }).then(function(){ refreshCart(true); });
  }

  function changeLine(key,qty){
    fetch(R.cartChange,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:key,quantity:qty})})
      .then(function(r){ if(!r.ok)throw 0; return r.json(); })
      .then(function(c){ renderCart(c); })
      .catch(function(){ refreshCart(false); }); /* e.g. 422 inventory cap — resync instead of rendering the error */
  }

  /* delegate clicks */
  document.addEventListener('click',function(e){
    var t=e.target;
    if(t.closest('[data-open-cart]')){e.preventDefault();refreshCart(true);}
    if(t.closest('[data-close-cart]')){e.preventDefault();closeCart();}
    var addBtn=t.closest('[data-add-to-cart]');
    if(addBtn && !addBtn.disabled){
      e.preventDefault();
      var id=addBtn.getAttribute('data-variant-id');
      if(id){ addBtn.classList.add('is-loading'); addToCart(id,1).then(function(){addBtn.classList.remove('is-loading');})
        .catch(function(){addBtn.classList.remove('is-loading');}); }
    }
    var minus=t.closest('[data-line-minus]'), plus=t.closest('[data-line-plus]');
    if(minus||plus){
      var row=t.closest('.citem'); if(!row)return;
      var key=row.getAttribute('data-key');
      var cur=parseInt(row.querySelector('.qty span').textContent,10);
      changeLine(key, plus?cur+1:cur-1);
    }
    var rm=t.closest('[data-line-remove]');
    if(rm){
      var rrow=t.closest('.citem');
      if(rrow)changeLine(rrow.getAttribute('data-key'),0);
    }
  });

  /* product form ajax */
  $all('form[data-product-form]').forEach(function(form){
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var btn=form.querySelector('[type=submit]');
      var data=new FormData(form);
      if(btn)btn.classList.add('is-loading');
      var errEl=form.querySelector('[data-form-err]');
      if(errEl)errEl.textContent='';
      fetch(R.cartAdd,{method:'POST',headers:{'Accept':'application/json'},body:data})
        .then(function(r){ if(!r.ok)return r.json().then(function(e){throw e;}); return r.json(); })
        .then(function(){refreshCart(true); if(btn)btn.classList.remove('is-loading');})
        .catch(function(err){
          if(btn)btn.classList.remove('is-loading');
          var msg=(err&&(err.description||err.message))||'Could not add to cart — please try again.';
          if(!errEl){
            errEl=document.createElement('p');
            errEl.setAttribute('data-form-err','');
            errEl.setAttribute('role','alert');
            errEl.style.cssText="color:var(--accent);font-family:'JetBrains Mono',monospace;font-size:12px;margin-top:10px";
            form.appendChild(errEl);
          }
          errEl.textContent=msg;
        });
    });
  });

  refreshCart(false);

  /* ---------- mobile menu ---------- */
  var mmenu=$('#mmenu');
  function setBurger(open){$all('[data-open-menu]').forEach(function(b){b.setAttribute('aria-expanded',open?'true':'false');});}
  document.addEventListener('click',function(e){
    if(e.target.closest('[data-open-menu]')){if(mmenu){mmenu.classList.add('show');setBurger(true);}}
    if(e.target.closest('[data-close-menu]')||(e.target.closest('#mmenu a'))){if(mmenu){mmenu.classList.remove('show');setBurger(false);}}
  });
  document.addEventListener('keydown',function(e){
    if(e.key!=='Escape'||!mmenu||!mmenu.classList.contains('show'))return;
    /* higher layers (popup z-120, drawer z-95) take priority over the menu (z-80) */
    if(document.querySelector('[data-popup].show'))return;
    if(drawer&&drawer.classList.contains('show'))return;
    mmenu.classList.remove('show');setBurger(false);
  });

  /* ---------- thermal reveal (hero) — mouse hover on desktop, drag/tap on touch ---------- */
  $all('[data-viewer]').forEach(function(viewer){
    var cold=viewer.querySelector('.cold'), temp=viewer.querySelector('[data-temp]'), hint=viewer.querySelector('.viewer__hint');
    if(!cold)return;
    function reveal(x,y){
      var r=viewer.getBoundingClientRect();
      cold.style.setProperty('--x',(x-r.left)+'px');
      cold.style.setProperty('--y',(y-r.top)+'px');
      if(temp)temp.textContent=(36.4+((y-r.top)/r.height)*4.5).toFixed(1)+'°C';
      if(hint)hint.style.opacity='0';
    }
    function reset(){cold.style.setProperty('--x','-200px');cold.style.setProperty('--y','-200px');if(hint)hint.style.opacity='';}
    if(window.PointerEvent){
      /* Pointer events unify mouse/touch/pen. For touch, pointermove only fires
         while a finger is down, so drag-to-reveal works; pointerdown handles tap.
         Mouse keeps hover-to-reveal and re-hides on leave (desktop unchanged). */
      viewer.addEventListener('pointerdown',function(e){reveal(e.clientX,e.clientY);});
      viewer.addEventListener('pointermove',function(e){reveal(e.clientX,e.clientY);});
      viewer.addEventListener('pointerleave',function(e){if(e.pointerType==='mouse')reset();});
    }else{
      viewer.addEventListener('mousemove',function(e){reveal(e.clientX,e.clientY);});
      viewer.addEventListener('touchmove',function(e){var tt=e.touches[0];reveal(tt.clientX,tt.clientY);},{passive:true});
      viewer.addEventListener('mouseleave',reset);
    }
  });

  /* ---------- tech crossfade slider ---------- */
  $all('[data-crossfade]').forEach(function(box){
    var slider=box.querySelector('input[type=range]'), cold=box.querySelector('.crossfade .cold'),
        out=box.querySelector('[data-slider-temp]');
    if(!slider)return;
    slider.addEventListener('input',function(){
      var v=+slider.value, max=+slider.max||40;
      if(cold)cold.style.opacity=(1-(v/max)).toFixed(2);
      if(out)out.textContent=v+'°C';
    });
  });

  /* ---------- faq ---------- */
  document.addEventListener('click',function(e){
    var q=e.target.closest('.faq__q'); if(!q)return;
    var item=q.parentElement, open=item.classList.contains('open');
    $all('.faq__item').forEach(function(i){
      i.classList.remove('open');
      var a=i.querySelector('.faq__a');if(a)a.style.maxHeight=null;
      var b=i.querySelector('.faq__q');if(b)b.setAttribute('aria-expanded','false');
    });
    if(!open){
      item.classList.add('open');
      q.setAttribute('aria-expanded','true');
      var a=item.querySelector('.faq__a');if(a)a.style.maxHeight=a.scrollHeight+'px';
    }
  });

  /* ---------- reveal on scroll ---------- */
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){en.target.classList.add('in');io.unobserve(en.target);}});},{threshold:.12});
    $all('.reveal').forEach(function(el){io.observe(el);});
  }else{$all('.reveal').forEach(function(el){el.classList.add('in');});}

  /* ---------- sticky buy bar ---------- */
  var buybar=$('#buybar'), anchor=$('#buybar-anchor');
  if(buybar){
    window.addEventListener('scroll',function(){
      var past=window.scrollY>700, hide=false;
      if(anchor){var r=anchor.getBoundingClientRect(); hide=(r.top<window.innerHeight&&r.bottom>0);}
      var shown=past&&!hide;
      buybar.classList.toggle('show', shown);
      /* the newsletter re-open chip yields to the buy bar (both sit at the bottom) */
      document.body.classList.toggle('buybar-visible', shown);
    });
  }

  /* ---------- countdown ---------- */
  $all('[data-countdown-ts]').forEach(function(cd){
    /* fixed real deadline (epoch seconds, computed server-side) — identical for every visitor */
    var end=parseInt(cd.getAttribute('data-countdown-ts'),10)*1000;
    if(!end)return;
    function p(n){return String(n).padStart(2,'0');}
    function tick(){
      var diff=end-Date.now();
      if(diff<=0){cd.hidden=true;clearInterval(iv);return;}
      var d=Math.floor(diff/864e5),h=Math.floor(diff%864e5/36e5),m=Math.floor(diff%36e5/6e4),s=Math.floor(diff%6e4/1e3);
      var set=function(sel,v){var el=cd.querySelector(sel);if(el)el.textContent=p(v);};
      set('[data-d]',d);set('[data-h]',h);set('[data-m]',m);set('[data-s]',s);
    }
    var iv=setInterval(tick,1000); tick();
  });

  /* ---------- product image carousel ---------- */
  $all('[data-gallery]').forEach(function(g){
    var slider=g.querySelector('[data-slider]'); if(!slider)return;
    var slides=$all('.pdp__slide',slider);
    var dots=$all('[data-dot]',g);
    var thumbs=$all('[data-thumb]',g);
    if(slides.length<2)return;
    function nearest(){
      var i=0,min=Infinity;
      slides.forEach(function(s,n){var d=Math.abs(s.offsetLeft-slider.scrollLeft);if(d<min){min=d;i=n;}});
      return i;
    }
    function goTo(i){ if(slides[i]) slider.scrollTo({left:slides[i].offsetLeft,behavior:'smooth'}); }
    function mark(i){ dots.forEach(function(d,n){d.classList.toggle('active',n===i);}); thumbs.forEach(function(t,n){t.classList.toggle('active',n===i);}); }
    g.addEventListener('click',function(e){
      var th=e.target.closest('[data-thumb]'); if(th){goTo(+th.getAttribute('data-index'));return;}
      var dot=e.target.closest('[data-dot]'); if(dot){goTo(dots.indexOf(dot));return;}
      if(e.target.closest('[data-slide-prev]')){goTo(Math.max(0,nearest()-1));}
      if(e.target.closest('[data-slide-next]')){goTo(Math.min(slides.length-1,nearest()+1));}
    });
    var t; slider.addEventListener('scroll',function(){clearTimeout(t);t=setTimeout(function(){mark(nearest());},90);});
  });

  /* ---------- product accordions ---------- */
  document.addEventListener('click',function(e){
    var q=e.target.closest('.acc__q'); if(!q)return;
    var item=q.parentElement, a=item.querySelector('.acc__a');
    var open=item.classList.toggle('open');
    q.setAttribute('aria-expanded', open?'true':'false');
    if(a) a.style.maxHeight = open ? a.scrollHeight+'px' : null;
  });

  /* ---------- localization picker (language / currency) ---------- */
  $all('[data-loc]').forEach(function(loc){
    var toggle=loc.querySelector('[data-loc-toggle]'), panel=loc.querySelector('[data-loc-panel]');
    if(!toggle||!panel)return;
    function close(){loc.classList.remove('is-open');panel.hidden=true;toggle.setAttribute('aria-expanded','false');}
    function open(){loc.classList.add('is-open');panel.hidden=false;toggle.setAttribute('aria-expanded','true');}
    toggle.addEventListener('click',function(e){e.stopPropagation();loc.classList.contains('is-open')?close():open();});
    document.addEventListener('click',function(e){if(!loc.contains(e.target))close();});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
  });

  /* ---------- newsletter popup ---------- */
  (function(){
    var popup=$('[data-popup]'); if(!popup)return;
    var KEY='luvz_popup_dismissed', KEY_DONE='luvz_popup_signedup', KEY_CHIP='luvz_chip_dismissed';
    var chip=$('[data-popup-chip]');
    var design=popup.getAttribute('data-design-mode')==='true';
    var freq=parseInt(popup.getAttribute('data-frequency'),10)||7;
    var delay=parseInt(popup.getAttribute('data-delay'),10);
    if(isNaN(delay))delay=5;

    function suppressed(){
      try{var v=localStorage.getItem(KEY);return v && (Date.now()<parseInt(v,10));}catch(e){return false;}
    }
    function suppress(days){
      try{localStorage.setItem(KEY,String(Date.now()+(days||freq)*864e5));}catch(e){}
    }
    function signedUp(){try{return !!localStorage.getItem(KEY_DONE);}catch(e){return false;}}
    function markSignedUp(){try{localStorage.setItem(KEY_DONE,'1');}catch(e){}}
    function chipDismissed(){
      try{var v=localStorage.getItem(KEY_CHIP);return v && (Date.now()<parseInt(v,10));}catch(e){return false;}
    }
    /* the chip invites people back to the offer after they closed the popup;
       never shown to subscribers, and its own × silences it for `freq` days */
    function showChip(){if(chip && !signedUp() && !chipDismissed())chip.hidden=false;}
    function hideChip(){if(chip)chip.hidden=true;}
    function open(){popup.classList.add('show');popup.setAttribute('aria-hidden','false');hideChip();
      /* the media image only downloads on first open, not on every page view;
         srcset must be set BEFORE src so the browser picks one candidate, once */
      var im=popup.querySelector('img[data-popup-src]');
      if(im){
        var ss=im.getAttribute('data-popup-srcset');if(ss)im.srcset=ss;
        im.src=im.getAttribute('data-popup-src');
        im.removeAttribute('data-popup-src');im.removeAttribute('data-popup-srcset');}
      var card=popup.querySelector('.popup__card');if(card)card.classList.add('in');}
    function close(){popup.classList.remove('show');popup.setAttribute('aria-hidden','true');
      suppress(signedUp()?365:freq); /* closing the success state must not shorten the post-signup pause */
      if(!signedUp())showChip();}

    popup.addEventListener('click',function(e){if(e.target.closest('[data-popup-close]'))close();});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&popup.classList.contains('show'))close();});
    if(chip){
      chip.addEventListener('click',function(e){
        if(e.target.closest('[data-popup-chip-close]')){
          try{localStorage.setItem(KEY_CHIP,String(Date.now()+freq*864e5));}catch(err){}
          hideChip();
          return;
        }
        if(e.target.closest('[data-popup-chip-open]'))open();
      });
    }

    /* In the theme editor: always show so the merchant can style it. */
    if(design){open();return;}

    /* Re-opened after a successful signup (Shopify reloads with ?customer_posted=true).
       Show the success state, then stop nagging for a long while. */
    if(/[?&]customer_posted=true/.test(location.search) && popup.querySelector('.popup__success')){
      markSignedUp();open();suppress(365);return;
    }

    if(signedUp())return;
    if(suppressed()){showChip();return;}
    if(delay<=0){open();}
    else{setTimeout(open,delay*1000);}
  })();

})();
